interface ActionProps {
  text: string;
  onClick: () => void;
}

export default function Action({ text, onClick }: ActionProps) {
  return (
    <button type="button" onClick={onClick} className="mt-5 flex-center text-neutral-400 text-xs hover:underline">
      {text}
    </button>
  );
}
